export default {
  googleAnalyticsId: process.env.REACT_APP_GOOGLE_ANALYTICS_ID,
};
